/**
 * Enlaces al panel anterior (CodeIgniter) y URLs externas.
 *
 * El panel legado se configura con `VITE_LEGACY_URL`. Si está vacío, la interfaz
 * simplemente no ofrece esos enlaces.
 */

import { env } from '@/config/env';

/** Compone la URL de una ruta del panel anterior, o `null` si no está configurado. */
export function buildLegacyUrl(ruta: string | null | undefined): string | null {
  if (!ruta || !env.legacyUrl) return null;

  // Las rutas absolutas (mesa de ayuda, sitios externos) se respetan tal cual.
  if (/^https?:\/\//i.test(ruta)) return ruta;

  return `${env.legacyUrl}/${String(ruta).replace(/^\/+/, '')}`;
}

/**
 * Resuelve el destino de un enlace del shell: URL absoluta, ruta del panel
 * anterior o `null` si no hay destino configurado.
 */
export function buildShellHref(link: { href?: string; legacyPath?: string }): string | null {
  if (link.href) return link.href;
  return buildLegacyUrl(link.legacyPath);
}
